import { Button } from "semantic-ui-react";

function StepConclusao({ nextStep }) {
  return (
    <>
      <h1 style={{ fontSize: "1.25em", textAlign: "center" }}>
        Seu pedido de filiação foi enviado para o Diretório Municipal.
      </h1>
      <p style={{ textAlign: "center" }}>
        O Diretório Municipal tem 7 dias úteis para analisar seu pedido de
        filiação. A gente te avisa por e-mail, mas você também poderá acompanhar
        tudo por aqui.
      </p>
      <p style={{ textAlign: "center" }}>
        Enquanto isso,{" "}
        <strong>
          você já pode escolher os Setoriais do PT que você quer participar
        </strong>
        .
      </p>
      <Button className="buttonAcaoMetade" onClick={nextStep} secondary>
        PREFIRO ESPERAR
      </Button>
      <Button className="buttonAcaoMetade" onClick={nextStep} primary>
        QUERO ESCOLHER OS SETORIAIS
      </Button>
    </>
  );
}

export default StepConclusao;
